"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const iconsCommon_1 = __importDefault(require("../../../iconsCommon"));
const QRIcon = (_a) => {
    var rest = __rest(_a, []);
    return (react_1.default.createElement(iconsCommon_1.default, Object.assign({ "data-icon": "facebook", viewBox: "0 0 16 16" }, rest),
        react_1.default.createElement("path", { d: "M3.50001 8.5001H7.50003V9.5001M9.50004 9.5001V12.5001H12.5001V9.5001H11.5M7.50003 11.5001V12.5001M7.50003 3.50008V6.50009H8.50003M10.5 7.5001H12.5001M0.5 4.00008V1.50007C0.5 0.947782 0.947717 0.500065 1.5 0.500065H4.00002M12.0001 0.500065H14.5001C15.0523 0.500065 15.5001 0.947782 15.5001 1.50007V4.00008M15.5001 12.0001V14.5001C15.5001 15.0524 15.0523 15.5001 14.5001 15.5001H12.0001M4.00002 15.5001H1.5C0.947717 15.5001 0.5 15.0524 0.5 14.5001V12.0001M3.50001 3.50008H5.50002V5.50009H3.50001V3.50008ZM3.50001 10.5001H5.50002V12.5001H3.50001V10.5001ZM10.5 3.50008H12.5001V5.50009H10.5V3.50008Z", stroke: "#0085FF", strokeLinecap: "round", strokeLinejoin: "round" })));
};
exports.default = QRIcon;
//# sourceMappingURL=QRIcon.js.map